import { createContext } from 'use-context-selector'
import { SignupContextProps } from './types'

export const SignupContext = createContext({} as SignupContextProps)
